import React, {useEffect} from 'react'
import {PartnerAboutSection} from 'pages/widgets'
import {ProvideWidget, useWidget} from 'util/widget'
import {useLocation} from 'util/router'
import { useDispatch, useSelector } from 'react-redux';
import { fetchInstructorData } from 'store/actions/widgetActions';
import {useCookies} from 'react-cookie'

import PricingSection from 'components/PricingSection'

export const REFERRAL_USER_ID = 'refferalUserId';
export const REFERRAL_WIDGET_NAME = 'refferalWidgetName';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

function Invitation(props) {


    const referralName = useQuery().get('ref')
    // console.log("location: ", location)
    // const widgetName = null

    const widget = useWidget()
    const [cookies, setCookie, removeCookie] = useCookies([REFERRAL_USER_ID, REFERRAL_WIDGET_NAME]);
    
    useEffect(() => {
        // console.log("useWidget: ", widget)
        if (widget && referralName) {
            setCookie(REFERRAL_WIDGET_NAME, referralName, { path: '/' })
            widget.setWidget(referralName)
        }
    }, [widget, referralName])

    const dispatch = useDispatch();
    useEffect(() => {
        if (widget && widget.widgetName) {
            dispatch(fetchInstructorData(widget.widgetName, "user"))
                .then(referralId => {
                    console.log("Referral UserId: ", referralId)
                    setCookie(REFERRAL_USER_ID, referralId, { path: '/' })
                })
        }
    }, [dispatch, widget]);

    const partnerReady = useSelector(state => !!(state.widget.instructor?.widgetName));
    const imageUrl = useSelector(state => state.widget.instructor.instructorProfile?.partnerImageUrl ?? state.widget.instructor.profileImageUrl);
    const partnerName = useSelector(state => state.widget.instructor.instructorProfile?.pageName ?? state.widget.instructor.firstName);

    const openInNewTab = () => {
        const url = 'https://rachellea901757.typeform.com/to/B2Sbz6?source=referral'
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
      }

    return (
    <div className="container d-flex flex-column">

        <div className={!partnerReady ? "d-none" : "text-center"}>
        
            <PartnerAboutSection
                show={true} 
                imageUrl={imageUrl} 
                about={""}
                className={"mt-3"}
            />

            <h3 className="mb-5">{partnerName} just invited you to join Sutra!</h3>

            <button className="btn btn-primary" onClick={openInNewTab}>Schedule a Demo</button>


            <br></br><br></br>

            <PricingSection
                bg="white"
                textColor="dark"
                size="md"
                bgImage=""
                bgImageOpacity={1}
                title="Get Started"
                subtitle=""
            ></PricingSection>

        </div>

    
    </div>
    )
}




function ReferralInvitationPage(props) {
    return (
        <ProvideWidget>
            <Invitation {...props} />
        </ProvideWidget>


        
    )
}

export default ReferralInvitationPage